import React, {useContext, useEffect, useState} from 'react';
import LoadingIndicator from '@src/components/LoadingIndicator/LoadingIndicator';
import classnames from '@src/helpers/classnames';
import {LayoutContext} from '@src/contexts/LayoutContext';
import useIsLoading from '@src/hooks/useIsLoading';

export default function HeaderSmartLoadingIndicator() {
    const {isLoadingIndicatorDisplayed, onUpdate} = useContext(LayoutContext);
    const [display, setDisplay] = useState(isLoadingIndicatorDisplayed());
    const isLoading = useIsLoading();

    useEffect(() => {
        const subscription = onUpdate(() => {
            setDisplay(isLoadingIndicatorDisplayed);
        });

        return () => subscription.unsubscribe();
    }, [isLoadingIndicatorDisplayed, onUpdate]);

    return <div className={classnames({
        'header__loading-indicator-wrapper': true,
        'header--display-loading-indicator': display || isLoading,
    })}>
        <LoadingIndicator type="linear" className="header__loading-indicator"/>
    </div>;
}
